import { isBeekeeperFeatureEnabled, isFeatureEnabled } from '@lumapps/features/ducks/selectors';
import { isInstanceSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { BEEKEEPER_INTEGRATION, BEEKEEPER_LUMAPPS_SINGLE_DOMAIN } from '../constants';

export const isBeekeeperIntegrationEnabled = isFeatureEnabled(BEEKEEPER_INTEGRATION);
const isLumappsSingleDomainDevelopmentEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_LUMAPPS_SINGLE_DOMAIN);

export const isBeekeeperAdminAllowed = createSelector(
    isBeekeeperIntegrationEnabled,
    isInstanceSuperAdmin,
    (isEnabled, isAdmin) => isEnabled && isAdmin,
);

export const isLumappsSingleDomainEnabled = createSelector(
    isBeekeeperIntegrationEnabled,
    isLumappsSingleDomainDevelopmentEnabled,
    (isIntegrationEnabled, isSingleDomainEnabled) => isIntegrationEnabled && isSingleDomainEnabled,
);
